

import EditBase from "./EditBase"
import ConstantDraw from "../constants/ConstantDraw"
class EditCircle extends EditBase {

    constructor(options) {
        super(options);
    }

    //初始化扩展属性
    static ext_cir_center = "edit_cir_center"; //中心点
    static ext_cir_outline = "edit_cir_outline"; //边缘点
    static ext_cir_centerP = "edit_cir_centerP"; //中心点实体
    static ext_cir_outlineP = "edit_cir_outlineP"; //边缘点实体

    initAttrPlot() {
        var $this = this;
        this.plot.attrPlot = this.plot.attrPlot || {};
        var keyPos = this.plot.attrPlot[EditBase.ext_positions]; //拿到关键点数组
        this.plot.attrPlot[EditBase.ext_id] = this.editGuid;
        this.plot.attrPlot[EditCircle.ext_cir_center] = keyPos[0];
        this.plot.attrPlot[EditCircle.ext_cir_outline] = keyPos[keyPos.length - 1];
        var ext_cir_center = this.createPoint(keyPos[0],ConstantDraw.Style_CenterPos);
        var ext_cir_outline = this.createPoint(keyPos[keyPos.length - 1],ConstantDraw.Style_KeyPos);
        ext_cir_center.attrPlot = {
            [EditBase.ext_id]: this.editGuid,
            p_type: 'c'
        };
        ext_cir_outline.attrPlot = {
            [EditBase.ext_id]: this.editGuid,
            p_type: 'l'
        };

        this.entities.push(ext_cir_center);
        this.entities.push(ext_cir_outline);

        this.plot.attrPlot[EditCircle.ext_cir_centerP] = ext_cir_center;
        this.plot.attrPlot[EditCircle.ext_cir_outlineP] = ext_cir_outline;

        var positionProperty = new $this.Cesium.CallbackProperty(function () {
            return $this.plot.attrPlot[EditCircle.ext_cir_center];
        }, false);
        var semiAxisProperty = new $this.Cesium.CallbackProperty(function () {
            var center = $this.plot.attrPlot[EditCircle.ext_cir_center];
            var outline = $this.plot.attrPlot[EditCircle.ext_cir_outline];
            //半径 两点间距离
            var r = Math.sqrt(
                Math.pow(center.x - outline.x, 2) +
                Math.pow(center.y - outline.y, 2)
            );
            return r ? r : r + 1;
        }, false);

        this.plot.position = positionProperty;
        this.plot.ellipse.semiMinorAxis = semiAxisProperty;
        this.plot.ellipse.semiMajorAxis = semiAxisProperty;
    }


    mouseMove(evt) {
        var $this = this;
        //关键点
        if (this.pick) {
            var cartesian = this.getCatesian3FromPX(evt.endPosition);
            $this.plot.attrPlot[EditCircle.ext_cir_outline] = cartesian;
            $this.plot.attrPlot[EditCircle.ext_cir_outlineP].position.setValue(cartesian);
        }

        //中心点
        if (this.center) {
            var cartesian = this.getCatesian3FromPX(evt.endPosition);
            $this.plot.attrPlot[EditCircle.ext_cir_center] = cartesian;
            $this.plot.attrPlot[EditCircle.ext_cir_centerP].position.setValue(cartesian);
            this.translateAll(cartesian);
        }
    }

    translateAll(position) {
        if (!this.positionMove) {
            this.positionMove = position;
        }
        //记录差值 
        var diff = Cesium.Cartesian3.subtract(position, this.positionMove, new Cesium.Cartesian3());
        this.positionMove = position;
        var $this = this;
        var newPos = Cesium.Cartesian3.add($this.plot.attrPlot[EditCircle.ext_cir_outline], diff, new Cesium.Cartesian3());
        $this.plot.attrPlot[EditCircle.ext_cir_outline] = newPos;
        $this.plot.attrPlot[EditCircle.ext_cir_outlineP].position.setValue(newPos);
    }

    leftClick(evt) {
        this.hideEdit();
        let pick = this.viewer.scene.pick(evt.position);
        var entity = this.getPickEnity(pick);
        if (entity && entity.attrPlot && entity.attrPlot[EditBase.ext_id] == this.editGuid) {
            this.showEdit();
        }
    }

    leftDown(evt) {
        this.pick = undefined;
        this.center = undefined;//中心点

        let pick = this.viewer.scene.pick(evt.position);
        var entity = this.getPickEnity(pick);
        if (entity && entity.attrPlot && entity.attrPlot['p_type'] == 'l' && entity.attrPlot[EditBase.ext_id] == this.editGuid) {
            this.pick = entity;
            this.viewer.scene.screenSpaceCameraController.enableRotate = false;//锁定相机
        }

        if (entity && entity.attrPlot && entity.attrPlot['p_type'] == 'c' && entity.attrPlot[EditBase.ext_id] == this.editGuid) {
            this.center = entity;
            this.viewer.scene.screenSpaceCameraController.enableRotate = false;//锁定相机
        }
    }

    leftUp(evt) {
        this.pick = undefined;
        this.center = undefined;//中心点
        this.positionMove = undefined;
        this.viewer.scene.screenSpaceCameraController.enableRotate = true;//解锁相机
    }

    showEdit() {
        this.plot.attrPlot[EditCircle.ext_cir_centerP].show = true;
        this.plot.attrPlot[EditCircle.ext_cir_outlineP].show = true;
    }

    hideEdit() {
        this.plot.attrPlot[EditCircle.ext_cir_centerP].show = false;
        this.plot.attrPlot[EditCircle.ext_cir_outlineP].show = false;
    }


}


export default EditCircle;

